var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleRelB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 24.5C49 38.031 38.031 49 24.5 49C10.969 49 0 38.031 0 24.5C0 10.969 10.969 0 24.5 0C38.031 0 49 10.969 49 24.5ZM6.01738 24.5C6.01738 34.7077 14.2923 42.9826 24.5 42.9826C34.7077 42.9826 42.9826 34.7077 42.9826 24.5C42.9826 14.2923 34.7077 6.01738 24.5 6.01738C14.2923 6.01738 6.01738 14.2923 6.01738 24.5Z",
    fill: "#F2F7F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleRelB);
export default __webpack_public_path__ + "static/media/IconCircleRelB.4aca4528466303a63c8c7d927e2f6087.svg";
export { ForwardRef as ReactComponent };